import Vue from 'vue';
import Vuetify, {
  VSnackbar,
  VIcon,
} from 'vuetify/lib';
import VuetifyToast from 'vuetify-toast-snackbar';
import ru from 'vuetify/es5/locale/ru';
import en from 'vuetify/es5/locale/en';
import { localeType } from '@/enums';

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VIcon,
  },
});

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#0A82D9',
        success: '#1FC57F',
      },
    },
  },
  lang: {
    locales: { ru, en },
    current: localeType.DEFAULT,
  },
  icons: {
    iconfont: 'mdiSvg',
  },
});

export default vuetify;

Vue.use(VuetifyToast, {
  $vuetify: vuetify.framework,
  y: 'top',
  timeout: 4000,
});
